module.exports = __webpack_public_path__ + "assets/img/driver-btn-0d5cac9a.png";